import React from 'react';
import MenuBar from './MenuBar';

const Layout = ({ children }) => {
    return (
        <div className="min-h-screen bg-warm-50">
            <MenuBar />
            <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
                {children}
            </main>
        </div>
    );
};

export default Layout;
